import { createFileRoute, redirect } from "@tanstack/react-router";
import { BrandLegacyRedirect } from "@/pages/legacy/LegacyRedirects";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/brand/$brandSlug/")({
  head: ({ params }) => routeHead("/uk/brand/$brandSlug/", params as Record<string, string>),
  // Redirect la nivel de rută (merge și la SSR, nu doar după hidratare).
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/uk/cars/${encodeURIComponent((params as { brandSlug: string }).brandSlug)}`, statusCode: 301 });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <BrandLegacyRedirect />
  );
}
